import { render, staticRenderFns } from "./FormSeal.vue?vue&type=template&id=6a149b9f"
import script from "./FormSeal.vue?vue&type=script&lang=js"
export * from "./FormSeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports